export default "__VITE_ASSET__DcbSkZj1__"